var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 30,
    viewBox: "0 0 38 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2118_10560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2 0H3.8C1.71 0 0.019 1.6875 0.019 3.75L0 26.25C0 28.3125 1.71 30 3.8 30H34.2C36.29 30 38 28.3125 38 26.25V3.75C38 1.6875 36.29 0 34.2 0ZM34.2 7.5L19 16.875L3.8 7.5V3.75L19 13.125L34.2 3.75V7.5Z",
    fill: "#142454"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2118_10560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueEmail);
export default __webpack_public_path__ + "static/media/blue_email.0bbe88f423823ecea6584735ce8dcf26.svg";
export { ForwardRef as ReactComponent };